import React, { useMemo } from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import useSwr from '@hooks/useSwr';
import StatCardInline from '@components/StatCardInline';

const Consumption = () => {
  const { t } = useTranslation('attributes');
  const { data, error } = useSwr('/service-proxy/api-charging/consumption');

  const contractNotFound = useMemo(
    () => error?.response?.status === 404,
    [error],
  );

  const stats = useMemo(() => {
    const items = [
      {
        key: 'dailyConsumption',
        title: t('dailyConsumption'),
        value: data?.requestConsumptionCurrentDay,
      },
      {
        key: 'validatedConsumption',
        title: t('validatedConsumption'),
        value: data?.requestConsumptionCurrentMonth,
      },
      {
        key: 'franchise',
        title: t('franchise'),
        value: data?.requestFranchise,
      },
    ];

    if (contractNotFound) {
      return items.map(item => ({ ...item, value: 0 }));
    }

    return items;
  }, [contractNotFound, data, t]);

  return (
    <Row gutter={[16, 16]}>
      {stats.map(({ key, title, value }) => (
        <Col key={key} xs={24} sm={12} lg={8}>
          <StatCardInline title={title} value={value} />
        </Col>
      ))}
    </Row>
  );
};

export default Consumption;
